import React, { useEffect, useState } from 'react';
import { CardDeck, Row, Col } from 'reactstrap';
import { sortBy } from 'lodash';
import { useFeatures } from '@cordata/buffet';

import { authorizedInstance as axios, CardItemLimit } from '~/utils';

import MedicalEvents from '~/components/MedicalEvent/Card';
import Notes from '~/components/Note/Card';
import Reminders from '~/components/Reminder/Card';
import Admissions from '~/components/Admission/Card';

type tMedicalEvent = {
  id: string,
};

const PatientFaceSheetNavigator = () => {
  const [medEvents, setMedEvents] = useState([] as tMedicalEvent[]);
  const { medicalEvent, admission, hasAppCit } = useFeatures();

  useEffect(() => {
    if (medicalEvent) {
      axios
        .get('reference-data/reference-medical-event')
        .then((r: any) => r.data.data)
        .then((r: any) => sortBy(r, ['attributes.defaultSortOrder']))
        .then(setMedEvents)
        .catch(console.error);
    }
  }, [medicalEvent]);

  return (
    <>
      <Row>
        {medicalEvent && medEvents.map((mE: tMedicalEvent) => (
          <Col key={mE.id} sm={3} className="mb-3">
            <MedicalEvents
              medicalEvent={mE}
            />
          </Col>
        ))}
      </Row>

      <CardDeck>
        {admission && <Admissions limit={CardItemLimit} />}
        <Notes />
        {!hasAppCit && <Reminders />}
      </CardDeck>
    </>
  );
};

export default PatientFaceSheetNavigator;

